<template>
  <div>
    <el-popover
        :popper-class="msgPopperClass"
        trigger="hover">
      <div class="is-error-msg">
        {{ errorMsg }}
      </div>
      <el-select
          ref="input"
          slot="reference"
          :class="{'is-error': errorMsg }"
          :value="inputValue | toString"
          :multiple="multiple"
          :disabled="disabled"
          :value-key="valueKey"
          :size="size"
          :clearable="clearable"
          :collapse-tags="collapseTags"
          :multiple-limit="multipleLimit"
          :auto-complete="autoComplete"
          :placeholder="placeholder"
          :filterable="filterable"
          :allow-create="allowCreate"
          :filter-method="filterMethod"
          :remote="remote"
          :remote-method="remoteMethod"
          :loading="loading"
          :loading-text="loadingText"
          :no-match-text="noMatchText"
          :no-data-text="noDataText"
          :popper-class="popperClass"
          :reserve-keyword="reserveKeyword"
          :default-first-option="defaultFirstOption"
          :popper-append-to-body="popperAppendToBody"
          :automatic-dropdown="automaticDropdown"
          @change="onChange"
          @focus="onFocus"
          @blur="onBlur">
        <el-option v-for="item in options"
            :key="item[optionsValueKey]"
            :label="item[optionsLabelKey]"
            :value="item[optionsValueKey] | toString">
          <slot :item="item" />
        </el-option>
      </el-select>
    </el-popover>
    <div v-show="!popoverErrorMsg && errorMsg"
        class="is-error-msg">
      {{ errorMsg }}
    </div>
  </div>
</template>

<script>

import _ from 'lodash'
import ValidCore from '@/components/atoms/BaseValidCore'

const isJSON = (sJSON) => {
  try {
    JSON.parse(sJSON)
    return true
  } catch (e) {
    return false
  }
}

export default {
  name: 'BaseValidSelect',
  filters: {
    toString: function (value) {
      if (Array.isArray(value)) {
        for (let i = 0; i < value.length; i++) {
          value[i] = value[i] != null ? value[i].toString() : ''
        }
        return value
      } else {
        return value != null ? value.toString() : ''
      }
    }
  },
  mixins: [ValidCore],
  props: {
    //  Attributes
    autoComplete: {
      type: String,
      default: 'off',
      validator: function (value) {
        return ['on', 'off'].indexOf(value) !== -1
      }
    },
    automaticDropdown: { type: Boolean, default: false },
    size: {
      type: String,
      default: undefined,
      validator: function (value) {
        return ['large', 'small', 'mini'].indexOf(value) !== -1
      }
    },
    disabled: { type: Boolean, default: false },
    clearable: { type: Boolean, default: false },
    filterable: { type: Boolean, default: false },
    allowCreate: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    popperClass: { type: String, default: undefined },
    remote: { type: Boolean, default: false },
    loadingText: { type: String, default: 'Loading' },
    noMatchText: { type: String, default: 'No matching data' },
    noDataText: { type: String, default: 'No data' },
    remoteMethod: { type: Function, default: undefined },
    filterMethod: { type: Function, default: undefined },
    multiple: { type: Boolean, default: false },
    multipleLimit: { type: Number, default: 0 },
    placeholder: { type: String, default: undefined },
    defaultFirstOption: { type: Boolean, default: false },
    reserveKeyword: { type: Boolean, default: false },
    valueKey: { type: Function, default: undefined },
    collapseTags: { type: Boolean, default: false },
    popperAppendToBody: { type: Boolean, default: true },
    options: {
      type: Array,
      default: function () {
        return []
      }
    },
    optionsValueKey: { type: String, default: 'code' },
    optionsLabelKey: { type: String, default: 'name' }
    /*
    options: [{
      value: 'Option1',
      label: 'Option1'
    }, ...]
    */
  },
  data () {
    return {
      whenFocused: null
    }
  },
  beforeMount () {
    if (this.multiple && !Array.isArray(this.inputValue)) {
      if (isJSON(this.inputValue)) {
        this.inputValue = JSON.parse(this.inputValue)
      } else {
        this.inputValue = []
      }
    } else if (!this.multiple && Array.isArray(this.inputValue)) {
      this.inputValue = null
    }
  },
  methods: {
    onChange (event) {
      if (event) {
        // 選択時
        if (Array.isArray(event)) {
          this.updateInputValue(
            _.chain(this.options)
              .filter((element) => _.find(event, (val) => val.toString() === element[this.optionsValueKey].toString()))
              .map(this.optionsValueKey)
              .value()
          )
        } else {
          this.updateInputValue(
            _.chain(this.options)
              .find((element) => event.toString() === element[this.optionsValueKey].toString())
              .get(this.optionsValueKey)
              .value()
          )
        }
      } else {
        // 選択解除時
        this.updateInputValue()
      }
    },
    onFocus (event) {
      this.whenFocused = _.cloneDeep(this.inputValue)
      this.$emit('focus', event)
    },
    onBlur (event) {
      this.$emit('blur', event, this.whenFocused, this.inputValue)
    },
    // 親からインプット要素をフォーカスするために使われる
    focus: function () {
      this.$refs.input.focus()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/atoms/BaseValidSelect.vue